exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".login-or{width:100%;display:block;text-align:center;position:relative;z-index:2;margin:0}.login-or span{background:#fff}.login-or:after{content:\"\";height:4px;background:#000;position:absolute;top:50%;transform:translateY(-50%);left:0;right:0;z-index:-1}", ""]);
